import { IconNames } from '@gousto-internal/citrus-react'

import { RecipeTag } from '@library/api-menu-experience/src/interfaces/recipe'

type AttributeType = RecipeTag['type']

const attributeIconMap: Record<AttributeType, IconNames> = {
  cookingTime: 'time',
  dairyFree: 'dairy_free',
  energy: 'calories',
  fiveADay: '5_a_day',
  glutenFree: 'gluten_free',
  plantBased: 'vegan',
  rating: 'rate_full',
  shelfLife: 'calendar',
  vegetarian: 'vegetarian',
  vegan: 'vegan',
  equipment: 'equipment',
}

export const mapAttributeTypeToIcon = (type: string): IconNames | null => {
  if (type in attributeIconMap) {
    return attributeIconMap[type as AttributeType]
  }

  return null
}
